import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import translate from '../../translate';

function OrderWizard({ t, activeStep }) {
  const step1 = cx('step-item', { active: activeStep >= 1, deactivate: activeStep < 1 });
  const step2 = cx('step-item', { active: activeStep >= 2, deactivate: activeStep < 2 });
  const step3 = cx('step-item', { active: activeStep >= 3, deactivate: activeStep < 3 });

  return (
    <div id="order-wizard" className="">
      <div className="order-wizard-stepper">
        <div className="order-title-wizard">{t('checkout.tab')}</div>
        <div className="order-wizard-container">
          <div className={`order-wizard-step ${activeStep === 1 ? '' : 'tabHidden'}`}>
            <div className={step1}>
              <div className="icon-holder">
                <div className="icon">
                  <i className="fa fa-shopping-bag" />
                </div>
              </div>
              {/* <div className="icon"><i className="fas fa-list-ul" /></div> */}
              <div className="description">
                <h2>1.</h2>
                <h3>{t('shop.cart.you_order')}</h3>
              </div>
            </div>
          </div>
          <div className={`order-wizard-step ${activeStep === 2 ? '' : 'tabHidden'}`}>
            <div className={step2}>
              <div className="icon-holder">
                <div className="icon">
                  <i className="fa fa-map-marker-alt" />
                </div>
              </div>
              <div className="description">
                <h2>2.</h2>
                <h3>{t('billing')}</h3>
              </div>
            </div>
          </div>
          <div className={`order-wizard-step ${activeStep === 3 ? '' : 'tabHidden'}`}>
            <div className={step3}>
              <div className="icon-holder">
                <div className="icon">
                  <i className="fa fa-credit-card" />
                </div>
              </div>
              <div className="description">
                <h2>3.</h2>
                <h3>{t('shop.cart.payment')}</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

OrderWizard.propTypes = {
  t: PropTypes.func.isRequired,
  activeStep: PropTypes.number.isRequired,
};

export default translate(OrderWizard);
